import { mapState } from "vuex"

const ui_utilities = {
    methods: {
        scroll_to (target, scroll_margin = null) {
            if(!target) return
            if(typeof target === "string") target = document.getElementById(target.replace(/^#/, ""))
            if(scroll_margin === null) scroll_margin = parseInt(getComputedStyle(target)["scroll-margin-top"]) || 0
            window.scrollTo({ top: target.getBoundingClientRect().y + window.scrollY - scroll_margin, left: 0, behavior: "smooth" })
        },
        record_edit (entity, id, event = null) {
            const route = { name: `${entity}.edit`, params: { id } }
            if(!!event && (!!event.ctrlKey || !!event.metaKey)) {
                const data = this.$router.resolve(route)
                window.open(data.href, "_blank")
            } else this.$router.push(route)
        },
        route_to_record (id, event = null, entity = "project") {
            this.record_edit(entity, id, event)
        },
        is_dark_color (hex_color) {
            // adapted from https://github.com/jamiebrittain/colourBrightness.js/blob/master/jquery.colourbrightness.js
            let red = 0
            let green = 0
            let blue = 0
            if(hex_color.length === 4) {
                red = parseInt(hex_color[1] + hex_color[1], 16)
                green = parseInt(hex_color[2] + hex_color[2], 16)
                blue = parseInt(hex_color[3] + hex_color[3], 16)
            } else {
                red = parseInt(hex_color.slice(1, 3), 16)
                green = parseInt(hex_color.slice(3, 5), 16)
                blue = parseInt(hex_color.slice(5, 7), 16)
            }
            const brightness = ((red * 299) + (green * 587) + (blue * 114)) / 1000

            return (brightness < 125)
        },
        change_color_hue (hex_color, percent) {
            // adapted from https://css-tricks.com/snippets/javascript/lighten-darken-color/
            const color = parseInt(hex_color.slice(1), 16)

            const red = Math.max(Math.min((color >> 16) + percent, 255), 0)
            const blue = Math.max(Math.min(((color >> 8) & 0x00FF) + percent, 255), 0)
            const green = Math.max(Math.min((color & 0x0000FF) + percent, 255), 0)

            return `#${(green | (blue << 8) | (red << 16)).toString(16)}`
        }
    },
    computed: {
        ...mapState(["app_context"]),
        small_screen () {
            return !!this.$mq.match(/^(sm|md)$/i)
        },
        medium_screen () {
            return !!this.$mq.match(/^(lg)$/i)
        },
        is_public_page () {
            return !this.$route.meta || (!this.$route.meta.login_required && !this.$route.meta.admin_route)
        },
        debugging () {
            return !!this.$cookie.get("debug-mode", "")
        }
    }
}

export default ui_utilities
